'use strict';
// **************************************************************
// * Code initially copied/adapted from "pony-cause" npm module *
// * Please upstream improvements there                         *
// **************************************************************
var isErrorLike = function(err) {
    return err && typeof err.message === 'string';
};
/**
 * @param {Error|{ cause?: unknown|(()=>err)}} err
 * @returns {Error|Object|undefined}
 */ var getErrorCause = function(err) {
    if (!err) return;
    /** @type {unknown} */ // @ts-ignore
    var cause = err.cause;
    // VError / NError style causes
    if (typeof cause === 'function') {
        // @ts-ignore
        var causeResult = err.cause();
        return isErrorLike(causeResult) ? causeResult : undefined;
    } else {
        return isErrorLike(cause) ? cause : undefined;
    }
};
/**
 * Internal method that keeps a track of which error we have already added, to avoid circular recursion
 *
 * @private
 * @param {Error} err
 * @param {Set<Error>} seen
 * @returns {string}
 */ var _stackWithCauses = function(err, seen) {
    if (!isErrorLike(err)) return '';
    var stack = err.stack || '';
    // Ensure we don't go circular or crazily deep
    if (seen.has(err)) {
        return stack + '\ncauses have become circular...';
    }
    var cause = getErrorCause(err);
    if (cause) {
        seen.add(err);
        return stack + '\ncaused by: ' + _stackWithCauses(cause, seen);
    } else {
        return stack;
    }
};
/**
 * @param {Error} err
 * @returns {string}
 */ var stackWithCauses = function(err) {
    return _stackWithCauses(err, new Set());
};
/**
 * Internal method that keeps a track of which error we have already added, to avoid circular recursion
 *
 * @private
 * @param {Error} err
 * @param {Set<Error>} seen
 * @param {boolean} [skip]
 * @returns {string}
 */ var _messageWithCauses = function(err, seen, skip) {
    if (!isErrorLike(err)) return '';
    var message = skip ? '' : err.message || '';
    // Ensure we don't go circular or crazily deep
    if (seen.has(err)) {
        return message + ': ...';
    }
    var cause = getErrorCause(err);
    if (cause) {
        seen.add(err);
        // @ts-ignore
        var skipIfVErrorStyleCause = typeof err.cause === 'function';
        return message + (skipIfVErrorStyleCause ? '' : ': ') + _messageWithCauses(cause, seen, skipIfVErrorStyleCause);
    } else {
        return message;
    }
};
/**
 * @param {Error} err
 * @returns {string}
 */ var messageWithCauses = function(err) {
    return _messageWithCauses(err, new Set());
};
module.exports = {
    isErrorLike: isErrorLike,
    getErrorCause: getErrorCause,
    stackWithCauses: stackWithCauses,
    messageWithCauses: messageWithCauses
};
